// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"542":"93e02494","688":"fea81068","842":"34cd4187","868":"40ba1528"}[chunkId] + ".chunk.css";
};